function getBaseUrl() {
  const mode = import.meta.env.MODE
  if (mode === "emulator") return "http://127.0.0.1:5301/rops-kanban/us-central1"
  if (mode === "dev-project") return "https://us-central1-dev-env-rops-kanban.cloudfunctions.net"
  return "https://us-central1-rops-kanban.cloudfunctions.net"
}

export const BASE_URL = getBaseUrl()
